const authors = [{
  name: "Sweta Singh",
  image: "/author.jpeg",
}];
  export default function AuthorsOfMonth() {
    return (
      <section className="bg-[#FFFBF4] px-6 ">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center mb-20">
          {/* <p className="tracking-[0.35em] text-xs text-[#565449] mb-4">
            OUR SERVICES
          </p> */}
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#11120D] mb-6">
            Author
          </h2>
          {/* <p className="text-[#565449] leading-relaxed">
            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          </p> */}
        </div>
  
        {/* Grid */}
        <div className="grid grid-cols-1 gap-14">
          {authors.map((author) => (
            <div key={author.name} className="text-center mx-auto">
              <div className="flex justify-center mb-8">
                <img
                  src={author.image}
                  alt={author.name}
                  className="w-44 h-44 rounded-full object-cover"
                />
              </div>
  
            
              <h3 className="font-serif text-xl text-[#11120D] mb-4">
                {author.name}
              </h3>
          
            </div>
          ))}
        </div>
      </section>
    );
  }
  